LS.util.route({
	'account': {
		'$guard:eval': {
			'hidden': {
				'$index': {
					':load': 'account.hidden',
					':unload': 'account.hidden:unload'
				}
			}
		}
	}
});